module.exports = __webpack_public_path__ + "img/vu.18a5b3f8.svg";